module.exports = __webpack_public_path__ + "img/metal_theopentoken.3430ecc.png";